// Default safe structure
const DEFAULT_PREVIEW = {
  pre_meta_title: "",
  pre_meta_url: "",
  pre_meta_desc: "",
  pre_meta_image: "",
  pre_meta_img_width: "",
  pre_meta_img_height: "",
  pre_meta_img_bgcolor: ""
};

// --- SAFE PARSER START ---
function extractJsonBlock(str) {
  const start = str.indexOf("{");
  const end = str.lastIndexOf("}");
  if (start === -1 || end === -1 || end <= start) return str;
  return str.slice(start, end + 1);
}

function escapeInnerQuotesForField(jsonStr, field) {
  const re = new RegExp(`("${field}"\\s*:\\s*")([\\s\\S]*?)"(?=\\s*(,|}))`, "g");
  return jsonStr.replace(re, (_, head, val, tail) => {
    const fixedVal = val.replace(/(?<!\\)"/g, '\\"');
    return `${head}${fixedVal}"`;
  });
}

function sanitizeToPotentialJson(str) {
  let s = String(str || "");
  s = s.replace(/[\u0000-\u001F\u007F-\u009F]/g, ""); // clean control chars
  s = extractJsonBlock(s);
  s = escapeInnerQuotesForField(s, "pre_meta_title");
  s = escapeInnerQuotesForField(s, "pre_meta_desc");
  return s;
}

function safeParsePreviewMetadata(input) {
  try {
    if (input && typeof input === "object") {
      return { ...DEFAULT_PREVIEW, ...input };
    }
    if (typeof input !== "string") return { ...DEFAULT_PREVIEW };

    try {
      return { ...DEFAULT_PREVIEW, ...JSON.parse(input) };
    } catch (_) {}

    const repaired = sanitizeToPotentialJson(input);
    try {
      return { ...DEFAULT_PREVIEW, ...JSON.parse(repaired) };
    } catch (e2) {
      console.error("preview_metadata parse failed after repair:", e2);
      return { ...DEFAULT_PREVIEW };
    }
  } catch (fatal) {
    console.error("preview_metadata fatal error:", fatal);
    return { ...DEFAULT_PREVIEW };
  }
}

function safeDecode(s) {
  try { return decodeURIComponent(s || ""); } catch { return s || ""; }
}
// --- SAFE PARSER END ---

// // 🔍 USAGE
// let previewMetadata = safeParsePreviewMetadata(post.preview_metadata);

// // Optional decoding
// previewMetadata.pre_meta_title = safeDecode(previewMetadata.pre_meta_title);
// previewMetadata.pre_meta_desc = safeDecode(previewMetadata.pre_meta_desc);

// // ✅ Result
// console.log("✅ Cleaned Preview Metadata:", previewMetadata);

export { 
    safeParsePreviewMetadata,
    safeDecode
};